import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Bot, Shield, Zap } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-700 to-blue-500 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-black/40 backdrop-blur-md shadow-xl rounded-lg p-8 border border-blue-500/20">
        <Link
          to="/"
          className="inline-flex items-center text-cyan-300 hover:text-cyan-200 transition-colors mb-8 group"
        >
          <ArrowLeft className="h-5 w-5 mr-2 transition-transform group-hover:-translate-x-1" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-white mb-8 bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          About AIX
        </h1>
        
        <div className="space-y-8">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">Our Mission</h2>
            <p className="text-gray-300 leading-relaxed">
              AIX was created with a vision to democratize algorithmic trading through the power of artificial intelligence.
              We provide a platform for club members to share knowledge, learn from each other, and explore the possibilities
              of automated trading in a safe and controlled environment.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">What We Offer</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-blue-900/40 p-6 rounded-lg">
                <Bot className="h-8 w-8 text-cyan-400 mb-4" />
                <h3 className="text-xl font-medium text-white mb-2">AI-Powered Trading</h3>
                <p className="text-gray-300">
                  Advanced algorithms that analyze market trends and execute trades with precision.
                </p>
              </div>
              <div className="bg-blue-900/40 p-6 rounded-lg">
                <Shield className="h-8 w-8 text-cyan-400 mb-4" />
                <h3 className="text-xl font-medium text-white mb-2">Risk Management</h3>
                <p className="text-gray-300">
                  Comprehensive risk management features to protect your investments.
                </p>
              </div>
              <div className="bg-blue-900/40 p-6 rounded-lg">
                <Zap className="h-8 w-8 text-cyan-400 mb-4" />
                <h3 className="text-xl font-medium text-white mb-2">Real-time Execution</h3>
                <p className="text-gray-300">
                  Lightning-fast execution to never miss trading opportunities.
                </p>
              </div>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">Our Community</h2>
            <p className="text-gray-300 leading-relaxed">
              We believe in the power of community. Our platform is built around the idea of shared learning and growth.
              Join our active community on <a href="https://t.me/teamiccc" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300">Telegram</a> to connect with other members,
              share insights, and stay updated on the latest developments.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">Disclaimer</h2>
            <p className="text-gray-300 leading-relaxed">
              AIX is designed for educational and entertainment purposes within our club community. Trading involves risk,
              and past performance is not indicative of future results. Always conduct your own research and consider your
              financial situation before making investment decisions.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
